import { Component, OnInit, Input, HostBinding } from '@angular/core'
import { ContextService } from '../../services/context.service'
import { MapMode } from '../../models/Vertical'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  standalone: false,
  selector: 'app-filter-city-selector',
  templateUrl: './filter-city-selector.component.html',
  styleUrls: ['./filter-city-selector.component.scss'],
})
export class FilterCitySelectorComponent implements OnInit {
  _poiList = []
  _selectedPOILabel = ''
  brandIcon = null

  @Input() loading = false

  @Input()
  get poiList() {
    return this._poiList
  }

  @HostBinding('class.disabled') get disabled() {
    return !this.context.canClearPoi()
  }

  set poiList(value) {
    this._poiList = value
    if (Array.isArray(value)) {
      const foundPoi = value.find((p) => p.value === this.selectedPOIValue)
      this.selectedPOILabel = (foundPoi && foundPoi.label) || ''
    }
  }

  get selectedPOILabel() {
    return this.isMapGridMode() && this.selectedPOIValue
      ? `Grid #${this.selectedPOIValue}`
      : this._selectedPOILabel || this.context.poiLabel
  }

  set selectedPOILabel(value) {
    this._selectedPOILabel = value
  }

  constructor(
    private context: ContextService,
    private sanitizer: DomSanitizer,
  ) {}

  get selectedPOIValue() {
    return this.context.poi
  }

  ngOnInit() {
    this.brandIcon = this.sanitizer.bypassSecurityTrustStyle(
      `--opt-brand-icon: url("/assets/img/brands/neighborhood/logo.svg")`,
    )
  }

  isMapGridMode() {
    return this.context.getMapMode() === MapMode.GRID
  }

  isMapMunicipalitiesMode() {
    return this.context.getMapMode() === MapMode.MUNICIPALITIES
  }

  canShowCitySearch() {
    return (
      (this.isMapGridMode() || this.isMapMunicipalitiesMode()) &&
      !this.selectedPOIValue
    )
  }

  canShowCitySelector() {
    return this.context.vertical.territories.length > 1
  }

  onPOISelected(event) {
    if (!this.loading) {
      this.selectedPOILabel = (event && event.label) || ''
      this.context.setPoi(event || null)
    }
  }
}
